/**
 * 开放应用权限码。与 admin-service 随 V153 迁移种入的权限码保持一致。
 *
 * 两点口径来自后端，不要在前端合并：
 * - 写权限**不含**查看权限：配置岗位必须同时勾 read 和所需写权限；
 * - SECRET（重置密钥）是**独立**权限，不能和 UPDATE 合成一个「编辑」按钮的显隐条件。
 */
export const OPEN_APP_READ = 'admin:open-app:read';
export const OPEN_APP_CREATE = 'admin:open-app:create';
export const OPEN_APP_UPDATE = 'admin:open-app:update';
export const OPEN_APP_SECRET = 'admin:open-app:secret';
